/* @sravni/react-design-system version 0.2.65 */
import { __rest, __read, __assign } from 'tslib';
import * as React from 'react';
import InputMask from 'react-input-mask';
import { useFormControlContext, useStyles, safeInvoke, isDefined } from '@sravni/react-utils';
import '../../TextInput/index.js';
import modules_8f2c8bee from '../styles/MaskInput.module.less.js';
import TextInput from '../../TextInput/src/TextInput.js';

/**
 * @description The Mask Input component allows user to type in text with mask
 *
 * @component
 * @example
 * ```jsx
 * <MaskInput placeholder="Дата" mask="99/99/9999" value={value} onChange={handleChange} />
 * ```
 */
var MaskInput = React.forwardRef(function (props, ref) {
    var defaultValue = props.defaultValue, value = props.value, mask = props.mask, placeholder = props.placeholder, className = props.className, onChange = props.onChange, restProps = __rest(props, ["defaultValue", "value", "mask", "placeholder", "className", "onChange"]);
    var _a = __read(React.useState(value || defaultValue), 2), innerValue = _a[0], setInnerValue = _a[1];
    var formControlContext = useFormControlContext();
    var cx = useStyles(modules_8f2c8bee);
    var classNames = cx(className, 'container');
    var inputProps = React.useMemo(function () { return (__assign(__assign({}, formControlContext), restProps)); }, [restProps, formControlContext]);
    var handleChange = function (event) {
        setInnerValue(event.currentTarget.value);
        safeInvoke(onChange, event);
    };
    React.useEffect(function () {
        isDefined(value) && setInnerValue(value);
    }, [value]);
    return (React.createElement("div", { "data-qa": "MaskInput", className: classNames },
        React.createElement(InputMask, __assign({ mask: mask, value: innerValue, onChange: handleChange }, inputProps),
            React.createElement(TextInput, { ref: ref, placeholder: placeholder }))));
});
MaskInput.defaultProps = {};
MaskInput.displayName = 'MaskInput';

export default MaskInput;
//# sourceMappingURL=MaskInput.js.map
